// src/pages/LoginHistoryPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataGrid, { Column, FilterRow, HeaderFilter, Paging, SearchPanel } from 'devextreme-react/data-grid';
import API_URL from '../config';

export default function LoginHistoryPage() {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API_URL}/api/login-history`)
            .then(res => {
                setHistory(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to fetch login history:", err);
                setLoading(false);
            });
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            <h2>Login History</h2>
            <DataGrid
                dataSource={history}
                keyExpr="HISTORY_ID"
                showBorders={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                hoverStateEnabled={true}
                loadPanel={{ enabled: loading }}
            >
                <Paging defaultPageSize={20} />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />

                <Column dataField="USER_ID" caption="User ID" />
                <Column dataField="USER_NAME" caption="User Name" />
                <Column dataField="LOGIN_TM" caption="Login Time" dataType="datetime" />
                <Column 
                    dataField="LOGIN_SUCCESS_YN" 
                    caption="Success" 
                    alignment="center"
                    cellRender={({ value }) => value === 'Y' ? '✅' : '❌'}
                />
                <Column dataField="INTERNAL_IP" caption="Internal IP" />
                <Column dataField="EXTERNAL_IP" caption="External IP" />
                <Column dataField="OS_INFO" caption="OS" />
                <Column dataField="BROWSER_INFO" caption="Browser" />
                <Column dataField="FAILURE_REASON" caption="Failure Reason" />
            </DataGrid>
        </div>
    );
}